import { LoaderCircle, ScanLine } from 'lucide-react';
import { useTranslation } from 'react-i18next';
export function ScannerActivity({ phase }: { phase: 'list' | 'scan' | 'saving' }) {
  const { t } = useTranslation();
  return <div role="status" className="flex items-center gap-3 rounded-xl border border-primary/20 bg-primary/5 p-4" data-scanner-activity={phase}>
    {phase === 'scan' ? <span className="relative inline-flex h-12 w-10 shrink-0 items-center justify-center overflow-hidden rounded-md border-2 border-primary/40" aria-hidden>
      <ScanLine className="h-6 w-6 text-primary" /><span className="scanner-scan-beam absolute inset-x-0 h-0.5 bg-primary" />
    </span> : <LoaderCircle aria-hidden className="h-6 w-6 shrink-0 animate-spin text-primary motion-reduce:animate-none" />}
    <span>{t(phase === 'list' ? 'scanner.loading' : phase === 'saving' ? 'scanner.saving' : 'scanner.scanning')}</span>
  </div>;
}
